import getProjection from "owa-popout-v2/lib/utils/getProjection";

export default function getTabIdFromWindow(targetWindow: Window): string {
    const projection = getProjection(targetWindow);
    return (projection ? projection.tabId : targetWindow === window ? "Main" : null) as string;
}
